class FontLoader {
  key = "font";

  async load(assetsPath, identifier) {
    try {
      const sourceFont = new FontFace(identifier, `url(${assetsPath})`);
      await sourceFont.load();
      document.fonts.add(sourceFont);
      return {
        content: {
          family: sourceFont.family,
          style: sourceFont.style,
          variant: sourceFont.variant,
          weight: sourceFont.weight,
        },
        representation: null,
      };
    } catch (e) {
      console.warn(`[AssetLoader] Failed to load font: ${assetsPath}`);
      // Return fallback - browser will use system font
      return {
        content: {
          family: identifier,
          style: 'normal',
          variant: 'normal',
          weight: 'normal',
        },
        representation: null,
      };
    }
  }
}

const fontLoader = new FontLoader();
export { fontLoader, FontLoader };
